<!--
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2023-03-16 16:00:23
 * @LastEditors: cuihaopeng cuihaopeng@slodon.cn
 * @LastEditTime: 2024-11-07 16:50:26
 * @FilePath: /aopumai_pc/src/views/member/connection/valet.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
  <div class="sld_after_sales_list">
    <MemberTitle memberTitle="代客下单" style="padding-left: 20px"></MemberTitle>
    <div class="after_sales_list_main">
      <div class="credit_tit">
        <div class="credit_name">
            <div>单位名称：{{ companyName }}</div>
            <div>客户名称：{{ memberName }}</div>
            
        </div>
         <div class="credit_name">
            <div>真实姓名：{{ member_info.data.memberTrueName?member_info.data.memberTrueName:'--' }}</div>
            <div>客户电话：{{ member_info.data.memberMobile?member_info.data.memberMobile:'--' }}</div>
        </div>
         <div class="credit_name">
            <div>可用余额：{{ member_info.data.creditBalanceAmount?member_info.data.creditBalanceAmount:'--' }}</div>
      
        </div>
      </div>
      <div class="cre_con">
        <div class="cre_tit">
          <div class="cre_tit_inventory">商品清单</div>
          <div class="add_cre_tit" @click="addProduct">
            <img src="@/assets/valet/ze_add.png" alt="" />添加商品
          </div>
        </div>
      </div>
      <div class="table_box" v-if="cartListIsTrue">
        <div class="table_th">
          <div class="shop">商品名称</div>
          <div class="brand">品牌</div>
          <div class="spec">规格</div>
          <div class="unit_price">原价</div>
          <div class="unit_price">折扣价</div>
          <div class="num">数量</div>
          <div class="icePack">是否干冰包装</div>
          <div class="subtotal">小计</div>
          <div class="subtotal">操作</div>
        </div>
        <div v-for="(it, index) in productList.data.promotionCartGroupList" :key="index">
          <div class="table_td" v-for="item in it.cartList" :key="item.cartId">
            <div class="shop">
            <img :src="item.productImage" alt="">
            <div class="shop_info"> <!-- 用新容器包裹三行文字 -->
              <div class="shop_name">{{ item.goodsName }}</div>
              <div class="shop_subject">{{ item.subjectName || '--' }}</div> <!-- 第二行：subjectName -->
              <div class="shop_code">{{ item.goodsCode || '--' }}</div> <!-- 第三行：goodsCode -->
            </div>            </div>
            <div class="brand">{{ item.brandName }}</div>
            <div class="spec">{{ item.specValues ? item.specValues : '--' }}</div>
            <div class="unit_price" style="text-decoration-line: line-through">{{ item.productPrice }}</div>
            <div class="unit_price">{{ item.productPrice }}</div>
            <div class="num">*{{ item.buyNum }}</div>
            <div class="icePack">{{ item.isNeedDrikold == 0 ? '不需要' : '需要' }}</div>
            <!-- <div class="subtotal">{{ item.offPrice == null ? (item.productPrice *
                      item.buyNum).toFixed(2) : ((item.productPrice - item.offPrice) * item.buyNum).toFixed(2) }}</div> -->
            <div class="subtotal">¥{{ (Number(item.productPrice) * item.buyNum).toFixed(2) }}</div>
            <!-- <div class="delete" @click="deleteProduct(item)">删除</div> -->
            <el-popconfirm :title="L['确定删除选中商品？']" @confirm="deleteProduct(item)" :confirmButtonText="L['确定']"
              :cancelButtonText="L['取消']">
              <template #reference>
                <span class="delete">{{ L["删除"] }}</span>
              </template>
            </el-popconfirm>
          </div>
        </div>


      </div>

      <div class="noData" v-if="!cartListIsTrue">暂无商品~</div>

      <el-pagination @current-change="handleCurrentChanges" background layout="prev, pager, next"
        :total="pagination.total" style="text-align: right;" v-if="productList.data.length > 0" />
      <div class="submit_btn" @click="submit_add" :class="!cartListIsTrue ? 'nodataActive' : ''">
        下单
      </div>
    </div>
    <el-dialog empty-text="暂无数据" v-model="ProductVisible" title="选择商品" width="1267px" :before-close="closeBtn">
      <div class="article_search_box">
        <div class="article_search">
          <el-input type="text" v-model="searchMemberId" placeholder="请输入产品名称/货号" />
          <div class="search_btn" @click="searchProduct">搜索</div>
        </div>
        <el-table :data="goodsList.data" stripe style="width: 1267px">
          <el-table-column align="center" label="产品名称" width="253">
          <template #default="scope">
            <!-- 用换行或空格分隔两个字段，可根据需求调整格式 -->
            <div>
              <span>{{ scope.row.goodsName }}</span>
              <br>
              <span class="subject-name">{{ scope.row.subjectName}}</span> <!-- 处理subjectName为空的情况 -->
            </div>
          </template>
          </el-table-column>
          <el-table-column prop="goodsCode" align="center" label="货号" width="153" />
          <el-table-column  align="center" label="商品状态" width="153">
            <template #default="scope">
              <div >{{ scope.row.goodsstate == 1?'待售商品':'在售商品' }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="getSpecValues" align="center" label="规格" width="153" />
          <el-table-column prop="productionTime" align="center" label="货期" width="120" />
          <el-table-column prop="originalPrice" align="center" label="原价（元)" width="153">
            <template #default="scope">
              <div style="text-decoration-line: line-through">￥{{ scope.row.originalPrice }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="productPrice" align="center" label="折扣价（元)" width="153">
            <template #default="scope">
              <div>￥{{ scope.row.productPrice }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="originalPrice" align="center" label="终端价（元)" width="153">
            <template #default="scope">
              <div >￥{{ scope.row.terminalGoodsPrice?scope.row.terminalGoodsPrice:'--' }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="productPrice" align="center" label="经销商价（元)" width="153">
            <template #default="scope">
              <div>￥{{ scope.row.dealerGoodsPrice?scope.row.dealerGoodsPrice:'--' }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="num" align="center" label="数量" width="153">
            <template #default="scope">
              <el-input-number v-model="scope.row.chooseNum" :min="1" size="small" :max="scope.row.productStock"
                @change="handleChange(scope.row)" />
            </template>
          </el-table-column>
          <el-table-column prop="address" align="center" label="操作" width="178">
            <template #default="scope">
              <img src="@/assets/shopping_cart.png" alt="" class="shopping_cart" @click="addGoods(scope.row)" />
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination_box">
          <el-pagination v-if="goodsList.data.length > 0" :current-page="pagination.current" background layout="prev, pager, next" :total="pagination.total"
            @current-change="handleCurrentGoodChange" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { useStore } from 'vuex'
import { onMounted, onBeforeUnmount, reactive, ref, getCurrentInstance, } from "vue";
import { ElMessage, ElPagination } from "element-plus";
import SldCommonEmpty from "../../../components/SldCommonEmpty";
import { useRouter, useRoute } from "vue-router";
import MemberTitle from "../../../components/MemberTitles";

export default {
  components: {
    ElPagination,
    MemberTitle,
    SldCommonEmpty,
  },
  setup() {
    const store = useStore()
    const { proxy } = getCurrentInstance();
    const L = proxy.$getCurLanguage();
    const router = useRouter();
    const route = useRoute()
    const ProductVisible = ref(false);
    const member_info = reactive({ data: {} });
    const companyName = ref("");
    const memberName = ref("");
    const memberid = ref("");
    const cartListIsTrue = ref(0)
    const pagination = reactive({
      current: 1,
      pageSize: 10,
      total: 0
    })
    const paginations = reactive({
      current: 1,
      pageSize: 10,
      total: 0
    })
    const searchMemberId = ref('') //搜索的货号

    const productList = reactive({ //商品清单列表
      data: []
    })
    const goodsList = reactive({
      data: []
    })
    const flag = ref(true) // 加入购物车锁

    // 模拟数据
    const table_list = reactive({
      data: [
        {
          date: 1,
          name: 1,
          address: 1,
          price: 1,
          num: 1,
        },
      ],
    });

    // 打开添加商品弹窗
    const addProduct = () => {
      ProductVisible.value = true;
      pagination.current = 1
      getProductList()
    };
    // 下单
    const submit_add = () => {
      if (cartListIsTrue.value == 0) {
        ElMessage.error('请添加商品')
        return
      }
      router.push({ path: `/member/connection/valetConfirm`, query: { ifcart: true, memberid: memberid.value,companyName:companyName.value,memberName:memberName.value } });
    }

    // 获取购物车列表
    const getAgentCart = () => {
      proxy.$get('v3/business/front/Agent/cart/cartList', { memberId: memberid.value }).then((res) => {
        if (res.state == 200) {
          productList.data = res.data
          cartListIsTrue.value = res.data.promotionCartGroupList.length

        }
      })
    }
    const handleCurrentChanges = (e) => {
      paginations.current = e
      getAgentCart()
    }

    const handleCurrentGoodChange = (e) => {
      pagination.current = e
      getProductList()
    }

    // 获取货品列表
    const getProductList = () => {
      let params = {}
      params.current = pagination.current
      params.pageSize = pagination.pageSize
      params.memberId = memberid.value
      params.productCode = searchMemberId.value
      proxy.$get('v3/goods/front/goods/productList', params).then((res) => {
        goodsList.data = res.data.list.map(v => {
          v.chooseNum = 1
          return v
        })
        pagination.total = res.data.pagination.total

      })
    }

    // 搜索货品
    const searchProduct = () => {
      pagination.current = 1
      getProductList()
    }
    // 改变购买数量
    const handleChange = (item) => {

    }
    // 添加购物车
    const addGoods = (item) => {
      let params = {}
      params.memberId = memberid.value
      params.productId = item.productId
      params.number = item.chooseNum
      if (flag.value == false) return
      proxy.$post('v3/business/front/Agent/cart/add', params).then((res) => {
        flag.value = true
        if (res.state == 200) {
          ElMessage.success({
            message: res.msg,
            type: "success"
          });
          getAgentCart()
        } else {
          ElMessage.error(res.msg)
        }
      })
    }

    // 删除商品
    const deleteProduct = (item) => {
      let params = {}
      params.cartIds = item.cartId
      params.memberId = memberid.value
      proxy.$post('v3/business/front/Agent/cart/deleteCarts', params).then((res) => {
        if (res.state == 200) {
          ElMessage.success({
            message: '删除成功',
            type: "success"
          });
          getAgentCart()
        } else {
          ElMessage.error(res.msg)
        }
      })
    }

    // 关闭弹窗按钮
    const closeBtn = () => {
      ProductVisible.value = false
      pagination.current = 1
      // 请求接口
      // getAgentCart()
    }
    const getInfo = () => {
        proxy
            .$get("v3/member/front/member/getInfo",{memberId:memberid.value})
            .then(res => {
                if (res.state == 200) {
                    member_info.data = res.data;
                } 
            })
            .catch(() => {
                //异常处理
            });
    };
    const innerHeight = window.innerHeight;
    onMounted(() => {
      // 非销售员 登录进来之后跳转首页
      if (store.state.memberInfo.isSale == 0) {
        router.push({ path: "/index" });
      }
      if (route.query.companyName) {
        companyName.value = route.query.companyName;
      }
      if (route.query.id) {
        memberid.value = route.query.id;
      }
      if (route.query.memberName) {
        memberName.value = route.query.memberName;
      }
      getInfo()
      getAgentCart()
      getProductList()
      if(innerHeight < 830){ // 对分辨率高度低于830的设备做兼容
          const TabFef = document.getElementById('fixed_tab');
          TabFef.style.top = 418 + 'px';
        }        
    });
    onBeforeUnmount(() => {
      if(innerHeight < 830){ // 对分辨率高度低于830的设备做兼容
          const TabFef = document.getElementById('fixed_tab');
          TabFef.style.top = '50%';
      }
    });
    return {
      L,
      ProductVisible,
      addProduct,
      table_list,
      submit_add,
      getInfo,
      companyName,
      memberid,
      memberName,
      productList,
      pagination,
      searchMemberId,
      goodsList,
      flag,
      paginations,
      cartListIsTrue,
      // searchProductCode,
      member_info,
      getAgentCart,
      getProductList,
      handleChange,
      searchProduct,
      addGoods,
      closeBtn,
      handleCurrentChanges,
      handleCurrentGoodChange,
      deleteProduct,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "../../../style/base.scss";
@import "../../../style/iconfont.css";

.sld_after_sales_list {
  width: 1007px;
  float: left;

  .after_sales_list_main {
    background-color: #fff;
    border: 1px solid #eee;
    margin-left: 10px;
    padding: 10px 0;
    height: 1080px;

    .credit_tit {
      width: 98%;
      margin: auto;
      background-color: rgba(37, 85, 170, 0.13);
      color: #2555aa;
      font-size: 14px;
      line-height: 27px;
      padding: 10px 20px;
      .credit_name {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
      }
    }
  }
}

.storeName {
  color: #333;

  &:hover {
    color: $colorMain;
  }
}

.noData {
  text-align: center;
  margin-top: 40px;
  color: #BEBEBE;
  font-size: 14px;
  margin-bottom: 60px;
}

.nodataActive {
  background-color: #9A9A9A !important;
  color: #fff !important;
}

.cre_con {
  .cre_tit {
    display: flex;
    justify-content: space-between;
    width: 98%;
    margin: 10px auto;
    color: rgba(16, 16, 16, 1);
    font-size: 18px;
    text-align: justify;
    font-family: SourceHanSansSC-regular;

    .cre_tit_inventory {
      font-weight: bold;
      padding-left: 10px;
    }

    .add_cre_tit {
      cursor: pointer;
      display: flex;
      align-items: center;

      img {
        width: 14px;
        height: 14px;
        margin-right: 5px;
      }

      color: rgba(37, 85, 170, 1);
      font-size: 12px;
      text-align: left;
      font-family: PingFangSC-regular;
    }
  }
}

.sld_after_sales_list {
  .article_search_box {
    // height: 600px;
    position: relative;
  }

  .article_search {
    display: flex;
    align-items: center;
    border: 1px solid rgba(37, 89, 132, 1);
    width: 516px;
    margin-bottom: 20px;

    input {
      width: 401px;
      height: 46px;
      color: rgba(136, 136, 136, 1);
      font-size: 14px;
      text-align: left;
      font-family: Microsoft Yahei;
      border: none;
      padding: 0 10px;
    }

    :deep(.el-input) {
      .el-input__inner {
        border: none;
        height: 46px;
      }
    }

    .search_btn {
      width: 113px;
      height: 46px;
      background-color: rgba(37, 89, 132, 1);
      color: rgba(255, 255, 255, 1);
      font-size: 14px;
      font-family: Microsoft Yahei;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }

  .shopping_cart {
    width: 17px;
    height: 17px;
    cursor: pointer;
  }

  .pagination_box {
    position: relative;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 10px;
  }

  .table_box {
    .table_th {
      height: 30px;
      width: 100%;
      padding: 0 20px;
      display: flex;
      align-items: center;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;

      div {
        height: 100%;
        line-height: 30px;
        border-bottom: 2px solid #cedbed;
        // margin-right: 3px;
      }

      .shop {
        // width: 275px;
        width: 226px;
        // padding-left: 85px;
        text-align: center;
      }

      .brand {
        width: 86px;
        text-align: center;
      }

      .spec {
        width: 125px;
        text-align: center;
      }

      .unit_price {
        width: 119px;
        text-align: center;
      }

      .num {
        width: 119px;
        text-align: center;
      }

      .icePack {
        width: 112px;
        text-align: center;
      }

      .subtotal {
        width: 84px;
        // text-align: right;
        text-align: center;
        // padding-right: 40px;
      }
    }

    .table_td {
      width: 100%;
      padding: 0 20px;
      display: flex;
      align-items: center;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      min-height: 100px;

      .shop {
        // width: 275px;
        width: 226px;
        align-items: flex-start; // 文字顶部对齐图片
        padding: 10px 5px;
        // padding-left: 85px;
        display: flex;

        img {
          width: 60px;
          height: 60px;
          flex-shrink: 0; // 图片不压缩，固定大小

        }.shop_info {
          // 文字容器占剩余空间，垂直排列
          margin-left: 10px;
          flex-grow: 1;

          .shop_name {
            color: rgba(16, 16, 16, 1);
            font-size: 14px;
            margin-bottom: 4px; // 与下一行保持间距
          }

          .shop_subject {
            color: #1078AF; // 可沿用原subject-name的颜色
            font-size: 12px;
            margin-bottom: 4px;
          }

          .shop_code {
            color: #666; // 货号用灰色区分
            font-size: 12px;
          }
        }

        // .shop_name {
        //   color: rgba(16, 16, 16, 1);
        //   font-size: 14px;
        //   text-align: left;
        //   height: 48px;
        //   font-family: SourceHanSansSC-regular;
        //   margin-left: 10px;
        //   display: -webkit-box; //谷歌
        //   -webkit-box-orient: vertical;
        //   -webkit-line-clamp: 3; //显示几行
        //   overflow: hidden;
        // }
      }

      .brand {
        width: 86px;
        text-align: center;
        padding: 5px;
      }

      .spec {
        width: 125px;
        text-align: center;
        padding: 5px;
      }

      .unit_price {
        width: 119px;
        text-align: center;
        padding: 5px;
      }

      .num {
        width: 119px;
        text-align: center;
        padding: 5px;
      }

      .icePack {
        width: 112px;
        text-align: center;
        padding: 5px;
      }

      .subtotal {
        width: 84px;
        // text-align: right;
        text-align: center;
        padding: 5px;
        color: #E8425B;
        // padding-right: 40px;
      }

      .delete {
        width: 84px;
        // text-align: right;
        text-align: center;
        padding: 5px;
        // color: #E8425B;
        cursor: pointer;

        &:hover {
          color: #2555aa;
        }
      }
    }
  }

  .submit_btn {
    width: 193px;
    height: 46px;
    border-radius: 3px;
    background-color: rgba(37, 89, 132, 1);
    color: rgba(255, 255, 255, 1);
    font-size: 18px;
    font-family: Roboto;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    margin-top: 10px;
    cursor: pointer;
  }
}


//分页图标背景
:deep(.el-pagination) {

  .btn-prev,
  .btn-next {
    .el-icon {
      width: 100%;
    }
  }

  .el-pager {
    .number {
      border: 1px solid #e8e8e8 !important;
    }

    .active {
      background-color: #fff !important;
      border: 1px solid $colorMain !important;
      color: #101010 !important;
    }
  }
}
</style>
<style lang="scss">
.article_search_box {
  tr {
    th {
      background-color: #f5f5f5;
      color: #000;
    }
  }

  .btn-next .el-icon,
  .el-pagination .btn-prev .el-icon {
    margin: auto;
  }
}

// :v-deep.el-input-number {
//   .el-input .el-input__inner {
//     border: none !important;
//   }
// }

.el-button--primary {
  color: #fff;
  background-color: $colorMain;
  border-color: $colorMain;

  &:hover {
    background-color: $colorMain;
    border-color: $colorMain;
  }
}
.subject-name {
  color: #1078AF; //
  // 可选：添加其他样式（如字号）
  // font-size: 12px;
}
</style>